import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacturacionIndexComponent } from './facturacion-index/facturacion-index.component';
import { FacturacionRoutingModule } from './facturacion-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImportacionPadronesComponent } from './importacion-padrones/importacion-padrones.component';
import { SharedModule } from '@shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CreditMemoPanelComponent } from './reportes/credit-memo-panel/credit-memo-panel.component';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { BrowserModule } from '@angular/platform-browser';
import { NgxPrintModule } from 'ngx-print';
import { ParametrosImpositivosIndexComponent } from './parametros-impositivos-v2/parametros-impositivos-index.component';
import { ListadoProvinciasComponent } from './parametros-impositivos-v2/listado-provincias/listado-provincias.component';
import { ListadoParametrosImpositivosComponent } from './parametros-impositivos-v2/listado-parametros-impositivos/listado-parametros-impositivos.component';
import { ParametrosImpositivosAgrupadosComponent } from './parametros-impositivos-v2/parametros-impositivos-agrupados/parametros-impositivos-agrupados.component';
import { ModalProvinciaV2Component } from './parametros-impositivos-v2/modal-provincia/modal-provincia-v2.component';
import { ModalCiudadV2Component } from './parametros-impositivos-v2/modal-ciudad/modal-ciudad-v2.component';
import { RemitosListaComponent } from './Remitos/remitos-lista/remitos-lista.component';
import { RemitosSeleccionComponent } from './Remitos/remitos-seleccion/remitos-seleccion.component';
import { RemitosFacturacionComponent } from './Remitos/remitos-facturacion/remitos-facturacion.component';
import { CorreccionPreciosComponent } from './correccion-precios/correccion-precios.component';
import { AprobacionRefacturacionComponent } from './aprobacion-refacturacion/aprobacion-refacturacion.component';
import { HoldeoAeroplantaComponent } from './holdeo/holdeo-aeroplanta/holdeo-aeroplanta.component';
import { HoldeoCuentasComponent } from './holdeo/holdeo-cuentas/holdeo-cuentas.component';
import { HoldeoAerovalesComponent } from './holdeo/holdeo-aerovales/holdeo-aerovales.component';
import { NuevoHoldeoComponent } from './holdeo/nuevo-holdeo/nuevo-holdeo.component';
import { DespachoRefacturacionComponent } from './despacho-refacturacion/despacho-refacturacion.component';
import { DespachoModule } from '../despacho/despacho.module';
import { RefacturacionIndexComponent } from './refacturacion-index/refacturacion-index.component';
import { HoldeoPrincipalComponent } from './holdeo/holdeo-principal/holdeo-principal.component';
import { RevisionRefacturacionComponent } from './revision-refacturacion/revision-refacturacion.component';
import { NivelesRefacturacionComponent } from './niveles-refacturacion/niveles-refacturacion.component';
import { ModalNivelRefacturacionComponent } from './niveles-refacturacion/modal-nivel-refacturacion/modal-nivel-refacturacion.component';
import { ReporteRemitosVencidosComponent } from './reportes/reporte-remitos-vencidos/reporte-remitos-vencidos.component';
import { ReportadorRemitosComponent } from './reportes/reporte-remitos/reportador-remitos/reportador-remitos.component';
import { RefacturacionHistorialComponent } from './refacturacion-historial/refacturacion-historial.component';
import { ComprobanteComponent } from './reportes/comprobante/comprobante.component';
import { ReporteFacturasComponent } from './reportes/reporte-facturas/reporte-facturas.component';
import { ReportesIndexComponent } from './reportes/reportes-index/reportes-index.component';
import { EjecucionesFacturacionComponent } from './reportes/ejecuciones/ejecuciones-facturacion/ejecuciones-facturacion.component';
import { DetalleEjecucionComponent } from './reportes/ejecuciones/detalle-ejecucion/detalle-ejecucion.component';
import { RefacturacionManualComponent } from './refacturacion-manual/refacturacion-manual.component';
import { VisorDocumentosComponent } from './documentos/visor-documentos/visor-documentos.component';
import { DocumentosIndexComponent } from './documentos/documentos-index/documentos-index.component'
import { TipoMovimientoPipe } from '@shared/pipes/tipo-movimiento.pipe';
import { NombreTipoComprobantePipe } from '@shared/pipes/nombre-tipo-comprobante.pipe';
import { FacturaNumeroPipe } from '@shared/pipes/factura-numero.pipe';
import { FacturaPrefijoPipe } from '@shared/pipes/factura-prefijo.pipe';
import { CondicionVentaPipe } from '@shared/pipes/condicion-venta.pipe';
import { ModalRefacturacionComponent } from "@facturacion/shared/components/modal-refacturacion/modal-refacturacion.component";
import { ReporteAnticipadoComponent } from "@facturacion/reporte-anticipado/reporte-anticipado.component";
import { InfiniteScrollDirective } from "ngx-infinite-scroll";
import { RefacturacionDevolucionLitrosComponent } from './refacturacion-devolucion-litros/refacturacion-devolucion-litros.component';
import { HistorialPadronesComponent } from "@facturacion/historial-padrones/historial-padrones.component";

@NgModule({
  declarations: [
    FacturacionIndexComponent,
    ImportacionPadronesComponent,
    HistorialPadronesComponent,
    ModalProvinciaV2Component,
    ModalCiudadV2Component,
    ComprobanteComponent,
    CreditMemoPanelComponent,
    ParametrosImpositivosIndexComponent,
    ListadoProvinciasComponent,
    ParametrosImpositivosAgrupadosComponent,
    ListadoParametrosImpositivosComponent,
    RemitosListaComponent,
    RemitosSeleccionComponent,
    RemitosFacturacionComponent,
    ReportadorRemitosComponent,
    HoldeoAeroplantaComponent,
    HoldeoCuentasComponent,
    HoldeoAerovalesComponent,
    NuevoHoldeoComponent,
    EjecucionesFacturacionComponent,
    CorreccionPreciosComponent,
    AprobacionRefacturacionComponent,
    ReportadorRemitosComponent,
    DespachoRefacturacionComponent,
    RefacturacionIndexComponent,
    DetalleEjecucionComponent,
    HoldeoPrincipalComponent,
    ReporteFacturasComponent,
    RevisionRefacturacionComponent,
    NivelesRefacturacionComponent,
    ModalNivelRefacturacionComponent,
    ReporteRemitosVencidosComponent,
    ReportesIndexComponent,
    RefacturacionManualComponent,
    RefacturacionHistorialComponent,
    ModalRefacturacionComponent,
    VisorDocumentosComponent,
    DocumentosIndexComponent,
    ReporteAnticipadoComponent,
    RefacturacionDevolucionLitrosComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    FacturacionRoutingModule,
    NgbModule,
    SharedModule,
    NgxSpinnerModule,
    NgbModule,
    NgxBarcode6Module,
    BrowserModule,
    NgxPrintModule,
    DespachoModule,
    InfiniteScrollDirective
  ],
  providers: [
    TipoMovimientoPipe,
    NombreTipoComprobantePipe,
    FacturaPrefijoPipe,
    FacturaNumeroPipe,
    CondicionVentaPipe
  ]
})
export class FacturacionModule { }
